import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-221ddf6d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_cont"
};
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import imagetext from "./imagetext.vue";
import { getCaseDetailApi } from "@/service/modules/case";
export default /*#__PURE__*/_defineComponent({
  __name: 'note-edit',
  props: {
    id: {
      type: Number,
      default: -1
    }
  },
  emits: ["pubsnote"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const tablist = ref([{
      label: "上传图文",
      name: 1
    }, {
      label: "上传视频",
      name: 2
    }]);
    const props = __props;
    const emit = __emit;
    const tabsActive = ref(1);
    const closeDialog = () => {
      emit("pubsnote");
    };
    const loading_w = ref(false);
    const item_Data = ref({});
    async function get_list() {
      if (props.id != -1) {
        loading_w.value = true;
        const res = await getCaseDetailApi(props.id);
        tabsActive.value = res.data.type;
        item_Data.value = res.data;
        console.log(res, "get_list");
        loading_w.value = false;
      }
    }
    get_list();
    return (_ctx, _cache) => {
      const _component_top_title = _resolveComponent("top-title");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_top_title, {
        message: "发布笔记"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_tabs, {
        modelValue: tabsActive.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tabsActive.value = $event),
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tablist.value, item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.name,
            name: item.name,
            label: item.label
          }, null, 8, ["name", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), tabsActive.value ? _withDirectives((_openBlock(), _createBlock(imagetext, {
        key: 0,
        tabsActive: tabsActive.value,
        item_Data: item_Data.value,
        onCloses: closeDialog
      }, null, 8, ["tabsActive", "item_Data"])), [[_directive_loading, loading_w.value]]) : _createCommentVNode("", true)])]);
    };
  }
});